import { useState, useEffect } from 'react';
import Axios from 'axios';

const useFetch = (endpoint, page, filters) => {
  const [results, setResults] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [facets, setFacets] = useState([]);
  const [loading, setLoading] = useState([]);
  const [resultsPerPage, setResultsPerPage] = useState(0);
  const [resultsInfo, setResultsInfo] = useState(0);


  useEffect(() => {
    const fetchData = async () => {
      const params = {};


      if (page) {
        params.page = page;
      }

      if (filters) {
        Object.keys(filters).forEach(key => {
          if (filters[key] === '') {
            params[key] = [];
          } else {
            params[key] = filters[key];
          }
        });
      }

      try {
        setLoading(true);
        const {
          data: {
            resultListing,
            totalResults,
            resultsPerPage,
            resultsInfo,
            page,
            facets: updatedFacets
          }
        } = await Axios({
          method: 'POST',
          url: endpoint,
          data: params
        });

        setTotalPages(Math.ceil(totalResults / resultsPerPage));
        setResults(page > 1 ? results.concat(resultListing) : resultListing);
        setFacets(updatedFacets);
        setResultsPerPage(resultsPerPage);
        setResultsInfo(resultsInfo);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [endpoint, page, filters]);

  return { totalPages, results, facets, loading, resultsPerPage, resultsInfo };
};

export default useFetch;
